import styled from 'styled-components'

export const CarDeliveryInfo = styled.div`
  display: flex;
  flex-direction: ${props => props.isModal ? 'column' : 'row'};
  align-items: ${props => !props.isModal && 'center'};
  margin: ${props => props.isSimulation ? '20px 0 10px 0' : '0 0 11px 0'};
`

export const CarDeliveryIcon = styled.img`
  width: 156px;
  height: 23px;
  margin-right: 19px;
`

export const Info = styled.div``

export const Text = styled.h3`
  font-weight: 500;
  font-size: 12px;
  line-height: 130%;
  color: #2E2D37;
`

export const Link = styled.a`
  font-weight: bold;
  font-size: 12px;
  line-height: 150%;
  color: #F3123C;
`
